import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'connected-react-router/immutable';

import { clearMfaChallenge, verifyMfaSetup } from 'actions/session';

import { getMfaEmail, getMfaSession, getOtpAuthUri, getSecretCode } from 'selectors/mfa';

import MfaSetup from 'components/mfa/MfaSetup';

import { LOGIN } from 'data/routes';

const mapStateToProps = state => ({
    email: getMfaEmail(state),
    session: getMfaSession(state),
    secretCode: getSecretCode(state),
    otpAuthUri: getOtpAuthUri(state),
});

const mapDispatchToProps = { verifyMfaSetup, clearMfaChallenge, replace };

const MfaSetupContainer = props => {
    const handleClickConfirm = useCallback(values => (
        props.verifyMfaSetup({ email: props.email, session: props.session, code: values.code })
    ), [props.email, props.session, props.verifyMfaSetup]);

    const handleClickCancel = useCallback(() => {
        props.clearMfaChallenge();
        props.replace(LOGIN);
    }, [props.clearMfaChallenge, props.replace]);

    return (
        <MfaSetup
            secretCode={props.secretCode}
            otpAuthUri={props.otpAuthUri}
            onClickCancel={handleClickCancel}
            onClickConfirm={handleClickConfirm}
        />
    );
};

MfaSetupContainer.propTypes = {
    email: PropTypes.string,
    session: PropTypes.string,
    secretCode: PropTypes.string,
    otpAuthUri: PropTypes.string,
    replace: PropTypes.func.isRequired,
    verifyMfaSetup: PropTypes.func.isRequired,
    clearMfaChallenge: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(memo(MfaSetupContainer));
